export const isInvisible = (uischema, schema, context) => {
    var _a, _b;
    return (_b = (_a = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _a === void 0 ? void 0 : _a.hidden) !== null && _b !== void 0 ? _b : false;
};
